import { ApiBase, Options, MethodInfo } from '../../core/ApiBase';
import { pList } from '../../models/.catalog';
import rList from '../../models/rList';
import { rOyakKiraBilgileriUstBilgiAkgDetay } from '../../models/rOyakKiraBilgileriUstBilgiAkgDetay';

export default class OyakKiraBilgileriUstBilgiAkgDetayApi extends ApiBase<
  pList,
  rList<rOyakKiraBilgileriUstBilgiAkgDetay>
> {
  constructor(options?: Options) {
    super(
      new MethodInfo({
        MethodUrl: '/OyakKiraBilgileriUstBilgiAkgDetay',
      }),
      options
    );
  }
}
